import UserDetails from './user-details';

export default UserDetails;
